import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {forwardRef, useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {getReportByTypeRange, getReportByTypeYearMonth} from "../common/api/ReportApi";
import {CardContent, Chip, Link} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import Loading from "../common/Loading";
import {formatDate, formatDateMask, formatDateTime} from "../common/Utils";
import BootyPagination from "../common/bootyPagination";
import DataTable from "react-data-table-component";
import * as pagination from "../common/pagination";
import {useForm} from "react-hook-form";
import Icon from "@mui/material/Icon";
import {BarChart} from '@mui/x-charts/BarChart';
import MDButton from "../../components/MDButton";
import StatisticsCard from "./card/StatisticsCard";
import dayjs from "dayjs";
import moment from "moment";
import {getCookie, setCookie} from "../common/appCookie";
import {Col} from "react-bootstrap";
import Switch from "@mui/material/Switch";
import FileSelector from "../calendarUI/FilterSelector";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import ActionItem from "../action/ActionItem";

export default function CustomerReportDetails({type, range, showRecurringMemberships, disableRange}) {
  const widthFn = () => {
    let w = parseInt(window.innerWidth, 10) * .5;
    return parseInt(window.innerWidth, 10) * .5;
  }
  const [docWidth, setDocWidth] = useState(100);

  useEffect(() => {
    function handleWidthFn() {
      setDocWidth(widthFn());
    }

    window.addEventListener("resize", handleWidthFn);
    handleWidthFn();
    return () => window.removeEventListener("resize", handleWidthFn);
  }, []);

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();
  const [reportPeriod, setReportPeriod] = useState();
  const [reportEndPeriod, setReportEndPeriod] = useState();
  const [reportData, setReportData] = useState();

  const [rangeReport, setRangeReport] = useState(range || false);

  const [eventDate, setEventDate] = useState();
  const [eventEndDate, setEventEndDate] = useState();

  const [membershipTypes, setMembershipTypes] = useState([]);
  const [membershipTypeFilter, setMembershipTypeFilter] = useState([]);


  const _BootyPagination = {...BootyPagination};

  let {reportYear, reportMonth, reportEndYear, reportEndMonth} = useParams();

  const setSalesData = () => {

    const filtered = resultsFiltered(reportData?.reportItems);

    let recurring = 0;
    let nonRecurring = 0;

    const chartData = [];

    for (const j in filtered) {
      for (const k in filtered[j].accounts) {
        if (filtered[j].accounts[k].recurring) {
          recurring += 1;
        } else {
          nonRecurring += 1;
        }
      }
    }

    const grouped = new Map();

    for (const item in filtered) {
      const membership = filtered[item];
      for (const k in membership.accounts) {
        const id = membership.accounts[k]?.accountType?.id;
        let go = false;
        if (!membershipTypeFilter || membershipTypeFilter.length === 0) {
          go = true;
        }
        if (!go && membershipTypeFilter.indexOf(id) > -1) {
          go = true;
        }
        if (!go) {
          continue;
        }
        const label = membership.accounts[k]?.accountType?.name;
        const value = 1;
        if (grouped.has(id)) {
          grouped.get(id).value += value;
        } else {
          grouped.set(id, {id, label, value});
        }
      }

    }

    const aGrouped = Array.from(grouped.values());
    setChartData(aGrouped);

    setRecurringMemberships(countMemberships(filtered, true));
    setNonRecurringMemberships(countMemberships(filtered, false));

  }

  useEffect(() => {
    setSalesData();
  }, [reportData, membershipTypeFilter]);

  const membershipTypeResultsFiltered = (data) => {
    if (!membershipTypeFilter || membershipTypeFilter.length === 0) {
      return data;
    }
    let _fd = [];
    let memberIds = [];
    for (const j in data) {
      let memberId = parseInt(data[j].id, 10);
      if (!memberId) {
        continue;
      }
      for (const k in data[j].accounts) {
        let account = data[j].accounts[k];
        let key = parseInt(account?.accountType?.id, 10);
        if (memberIds.indexOf(memberId) > -1) {
          continue;
        }
        if (membershipTypeFilter.indexOf(key) > -1) {
          memberIds.push(memberId);
          _fd.push(data[j]);
        }
      }
    }
    return _fd;
  }

  const resultsFiltered = (data) => {
    let arr1 = membershipTypeResultsFiltered(data);
    return arr1;
  }

  useEffect(() => {

    let _period = reportYear + '/' + reportMonth;
    setReportPeriod(_period);
    let _d = new Date();
    _d.setFullYear(reportYear);
    let m = moment(reportMonth, 'MMM')
    _d.setMonth(m.month());
    setEventDate(_d);

    if (!range) {
      setReportEndPeriod(_period);
      setEventEndDate(_d);

      getSalesReportByYearMonthFn(_period);

      return;
    }

    let _endPeriod = reportEndYear + '/' + reportEndMonth;
    setReportEndPeriod(_endPeriod);
    getSalesReportByYearMonthFn(_endPeriod);
    let _dd = new Date();
    _dd.setFullYear(reportEndYear);
    let mm = moment(reportEndMonth, 'MMM')
    _dd.setMonth(mm.month());

    setReportEndPeriod(_endPeriod);
    setEventEndDate(_dd);

    getSalesReportByRangeFn(_period, _endPeriod);

  }, []);

  useEffect(() => {
    _BootyPagination.reportData = {...reportData};
  }, [reportData]);


  const [labels, setLabels] = useState();
  const [chartData, setChartData] = useState();

  const formatChartData = (report) => {
    setChartData(report?.pieChartData);

    let types = [];
    for (const j in report?.pieChartData) {
      types.push({
        id: report?.pieChartData[j].id,
        sortOrder: report?.pieChartData[j].id,
        name: report?.pieChartData[j].label
      });
    }

    setMembershipTypes(types);
  }

  const displayMemberships = (member) => {

    let comps = [];
    let _recurringCount = 0;
    let _nonRecurringCount = 0;
    let hasRecurring = false;
    member.accounts.map(account => {
      if (account?.accountType?.recurring) {
        _recurringCount++;
      } else {
        _nonRecurringCount++;
      }
    });
    if (_recurringCount > 0) {
      comps.push(<Chip label={'Recurring ' + _recurringCount}
                       variant="outlined"
                       color="secondary"/>)
    }
    if (_nonRecurringCount > 0) {
      comps.push(<Chip label={'Non-Recurring ' + _nonRecurringCount}
                       variant="outlined"
                       color="secondary"/>)
    }
    return (comps.map((comp, idx) => {
      return (<span style={{marginRight: '4px'}} key={idx}>{comp}</span>)
    }));
  }

  const getSalesReportByYearMonthFn = (period) => {

    setReportData(null);

    getReportByTypeYearMonth(type, period).then(r => {
      if (r.error) {
        setContext({...context, error: {message: r.message}});
        setReportData({});
      } else {
        setReportData(r);
        formatChartData(r);
      }
    });

  }


  const getSalesReportByRangeFn = (startPeriod, endPeriod) => {

    setReportData(null);

    getReportByTypeRange(type, startPeriod, endPeriod).then(r => {
      if (r.error) {
        setContext({...context, error: {message: r.message}});
        setReportData({});
      } else {
        setReportData(r);
        formatChartData(r);
      }
    });

  }


  const DisplayReferenceId = ({tableRow}) => {

    const [row, setRow] = useState(tableRow);
    let id = row.referenceId;
    let descPart = id.substring(0, 3);
    let finalPart = id.substring(id.length - 4, id.length);
    return (
      <span
        className="cursor-pointer"
        onClick={() => {
          let _r = {...row};
          _r.fullId = !!!_r.fullId;
          setRow(_r);
        }}>
        {row.fullId ? <>{id}</> :
          <Chip
            label={descPart + '...' + finalPart}
            variant="outlined"
            color="secondary"

          />
        }
      </span>
    )
  }
  const handleViewCustomer = (row) => {
    navigate('/client/' + row.guid);
  }

  const customNullsLastSorter = (a, b, sortOrder) => {
    // Handle nulls: always put nulls at the end
    if (a === null && b === null) {
      return 0; // Both null, consider them equal
    } else if (a === null) {
      return 1; // 'a' is null, put it after 'b'
    } else if (b === null) {
      return -1; // 'b' is null, put it after 'a'
    }

    // Perform regular sorting if neither is null
    if (sortOrder === 'asc') {
      // Example for numeric sorting
      return a - b;
      // For string sorting: return a.localeCompare(b);
    } else { // sortOrder === 'desc'
      // Example for numeric sorting
      return b - a;
      // For string sorting: return b.localeCompare(a);
    }
  };


  const _columns = [
    {
      name: <span className='th'>Customer</span>,
      id: 1,
      selector: row => row.lastName.toUpperCase() + '-' + row.firstName?.toUpperCase(),
      cell: row => {
        return <Link className="link"
                     href={'/client/' + row.guid}>
          {row.lastName + (row.firstName ? ', ' + row.firstName : '')}
        </Link>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Email</span>,
      id: 2,
      selector: row => row?.email?.toUpperCase(),
      cell: row => {
        return <>{row.email && <Link className="link"
                                     href={'/email/client/' + row.guid + '?address=' + row.email}>
          {row.email}
        </Link>}&nbsp;</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Member Since</span>,
      id: 3,
      selector: row => row.createDate,
      cell: row => {
        return formatDateTime(row.createDate);
      },
      sortType: (a, b) => {
        return new Date(b.values.createDate) - new Date(a.values.createDate);
      },
      sortable: true,
    },
    {
      name: <span className='th'>Next Billing Date</span>,
      id: 16,
      omit: !showRecurringMemberships,
      selector: row => row.nextBillingDate ? new Date(row.nextBillingDate).getTime() : -1,
      cell: row => {
        return <>{row?.nextBillingDate ? formatDate(row.nextBillingDate) : ''}</>;
      },
      sortType: (a, b) => {
        return new Date(b.values.nextBillingDate).getTime() - new Date(a.values.nextBillingDate).getTime();
      },

      sortable: true,
    },
    {
      name: <span className='th'>Memberships</span>,
      id: 14,
      selector: row => row.guid,
      cell: row => {
        return <>{displayMemberships(row)}</>;
      },
      sortable: false,
    },
    {
      name: <span className='th'>Created By</span>,
      id: 15,
      selector: row => row.createUser?.lastName,
      cell: row => {
        return <>{row.createUser?.lastName + (row.createUser?.firstName ? ', ' + row.createUser?.firstName : '')}</>;
      },
      sortable: true,
    },
  ];

  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [columns, setColumns] = useState(_columns);
  const [searchParams, setSearchParams] = useSearchParams();
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };

  const [render, setRender] = useState(0);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);

  const exportCsv = () => {

    const d = resultsFiltered(reportData?.reportItems)

    let filename = 'Member-Export-' + formatDateMask(new Date(), 'MM-DD-YYYY-hh-mm-ss') + '.csv';

    let rows = [];
    let _dd = [];

    _dd.push("Customer Last Name");
    _dd.push("Customer First Name");
    _dd.push("Member Since");
    _dd.push("Email");
    _dd.push("Next Billing Date");
    _dd.push("Memberships");
    _dd.push("Created By");

    rows.push(_dd);

    for (let j in d) {
      let memberships = [];
      for (let k in d[j].accounts) {
        if (memberships.indexOf(d[j].accounts[k].accountType.name) == -1) {
          let nextBillDate = '';
          if (d[j].accounts[k].nextBillDate != null) {
            nextBillDate = ' - ' + formatDate(d[j].accounts[k].nextBillDate);
          }
          memberships.push(d[j].accounts[k].accountType.name + nextBillDate);
        }
      }
      let _dd = [];
      _dd.push(d[j].lastName);
      _dd.push(d[j].firstName);
      _dd.push(formatDateTime(d[j].createDate));
      _dd.push(d[j].email);
      _dd.push(d[j].nextBillingDate ? formatDate(d[j].nextBillingDate) : '');
      _dd.push(memberships.join(', '))
      _dd.push(d[j].createUser?.lastName + ', ' + d[j].createUser?.firstName);

      rows.push(_dd);
    }

    let data = rows.map(row =>
      row
        .map(String)  // convert every value to String
        .map(v => v.replaceAll('"', '""'))  // escape double quotes
        .map(v => `"${v}"`)  // quote it
        .join(',')  // comma-separated
    ).join('\r\n');

    var blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);

    setCookie('CUSTOMER_REPORT_SORT', column.id);
    setCookie('CUSTOMER_REPORT_SORT_DIR', sortDirection);

    setRender(render + 1);

  };

  const updateEventDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventDate(_d);
    setReportPeriod(_period);
  }

  const toggleReportRange = () => {
    setRangeReport(!rangeReport);
  }

  const getReport = () => {
    if (rangeReport) {
      getSalesReportByRangeFn(reportPeriod, reportEndPeriod);
      navigate(`/${type}/report/${reportPeriod}/${reportEndPeriod}`, {replace: true});
    } else {
      getSalesReportByYearMonthFn(reportPeriod);
      navigate(`/${type}/report/${reportPeriod}`, {replace: true});
    }
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <span className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <MDTypography variant="h5" color="secondary" fontWeight="light" sx={{
        display: 'inline-block'
      }}>
        <Icon sx={{
          marginTop: '2px',
        }}>event</Icon>Report Date - {formatDateMask(eventDate, 'MMMM yyyy')}
      </MDTypography>
    </span>
  ));

  const countMemberships = (data, condition) => {
    let _count = 0;
    if (!data) {
      return _count;
    }
    data?.map(row => {
      row.accounts.map(account => {
        if (account.accountType.recurring === condition) {
          _count++;
        }
      })
    });
    return _count;
  }

  const [recurringMemberships, setRecurringMemberships] = useState(0);
  const [nonRecurringMemberships, setNonRecurringMemberships] = useState(0);

  const updateEventEndDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventEndDate(_d);
    setReportEndPeriod(_period);
  }

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);

  const handleRowSelected = React.useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleClearRows = () => {
    setToggledClearRows(!toggledClearRows);
  };

  const [actionItem, setActionItem] = useState(null);
  const [actionItemActive, setActionItemActive] = useState(false);
  const [actionRecipients, setActionRecipients] = useState([]);

  const startAddTags = () => {
    setActionItem('addTags');
    setActionItemActive(true);

    let ids = []
    for (const j in selectedRows) {
      ids.push(selectedRows[j].guid);
    }
    setActionRecipients(ids);
  }

  const composeEmail = () => {

    setActionItem('composeEmail');
    setActionItemActive(true);

    let ids = []
    for (const j in selectedRows) {
      ids.push(selectedRows[j].guid);
    }
    setActionRecipients(ids);
  }

  const valueFormatter = (value) => (value);

  return (

    <DashboardLayout>

      <Meta pageTitle={'Member Report'}/>

      <ContextSearchNavbar title="Member Report"/>

      <MDBox py={3}>
        <MDBox mb={3}>
          {!reportData && <Loading/>}
          {reportData && <Grid container spacing={1} mb={2}>
            <Grid item xs={12} sm={8}>
              <DesktopDatePicker
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '4px 0 0 4px'
                  }
                }}
                closeOnSelect={false}
                views={['month', 'year']}
                maxDate={dayjs()}
                slotProps={{
                  actionBar: {
                    actions: ['today', 'accept'],
                  },
                }}
                value={dayjs(eventDate)}
                onChange={(e) => {
                  updateEventDates(e?.$d || null);
                }}
              />
              {rangeReport &&
                <DesktopDatePicker
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '4px 0 0 4px'
                    }
                  }}
                  closeOnSelect={false}
                  views={['month', 'year']}
                  minDate={dayjs(eventDate)}
                  maxDate={dayjs()}
                  slotProps={{
                    actionBar: {
                      actions: ['today', 'accept'],
                    },
                  }}
                  value={dayjs(eventEndDate)}
                  onChange={(e) => {
                    updateEventEndDates(e?.$d || null);
                  }}
                />}
              <MDButton
                sx={{
                  borderRadius: '0 4px 4px 0',
                  height: '44px'
                }}
                color="info"
                onClick={() => {
                  getReport();
                }}
              >Go</MDButton>
            </Grid>
            <Grid item xs={12} sm={4} justifyContent="flex-end" alignItems="flex-end" style={{
              paddingRight: '12px'
            }}>
              <FileSelector
                width={'100%'}
                types={membershipTypes}
                typeFilter={membershipTypeFilter}
                filterLabel={'Membership Types'}
                labelBackground={'#f0f2f5'}
                setFilter={(filters) => {
                  setMembershipTypeFilter(filters);
                  handleClearRows();
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {!disableRange && <Col xs={12}>
                <label
                  htmlFor="rangeReport">
                  Date Range
                  <Switch
                    name={'rangeReport'}
                    id={'rangeReport'}
                    checked={rangeReport}
                    style={{marginRight: '5px'}}
                    onChange={toggleReportRange}
                  /> </label>
              </Col>}
            </Grid>

            <Grid item sm={8} xs={12}>
              <Card>
                <CardContent sx={{
                  height: '320px'
                }}>
                  <MDTypography variant="h5" fontWeight={"light"}>
                    Membership Types
                  </MDTypography>
                  {chartData && <BarChart
                    tooltip={{trigger: 'item'}}
                    grid={{vertical: true, horizontal: true}}
                    dataset={chartData}

                    xAxis={[
                      {
                        scaleType: 'band',
                        dataKey: 'label',
                        colorMap: {
                          type: 'ordinal',
                          colors: ['#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e']
                        }
                      }
                    ]}
                    series={[{dataKey: 'value', valueFormatter}]}
                    width={docWidth}
                    height={300}
                  />}
                </CardContent>
              </Card>
            </Grid>
            <Grid item sm={4} xs={12}>
              {showRecurringMemberships && <StatisticsCard
                title="Recurring Memberships"
                count={recurringMemberships}
                percentage={{
                  color: "success",
                  label: "Total Recurring Memberships for period",
                }}
              />
              }

              <div className={showRecurringMemberships ? 'mt-2' : 'd-normal'}>

                <StatisticsCard
                  title="Non-Recurring Memberships"
                  count={nonRecurringMemberships}
                  percentage={{
                    color: "success",
                    label: "Total Non-Recurring Memberships for period",
                  }}
                />
              </div>
            </Grid>

            <Card sx={{
              marginTop: '15px',
              width: '100%'
            }}>
              <CardContent>

                <MDButton
                  className="pull-right mx-1"
                  color="secondary"
                  size="small"
                  onClick={exportCsv}><span className="fa fa-file-excel"></span>&nbsp;Export</MDButton>

                <MDButton
                  className="pull-right mx-1"
                  color="secondary"
                  size="small"
                  disabled={!selectedRows || selectedRows?.length === 0}
                  onClick={() => {
                    startAddTags()
                  }}><Icon>label_important</Icon>&nbsp;Add Tags</MDButton>

                <MDButton
                  className="pull-right mx-1"
                  color="secondary"
                  size="small"
                  disabled={!selectedRows || selectedRows?.length === 0}
                  onClick={() => {
                    composeEmail()
                  }}><Icon>email</Icon>&nbsp;Compose Email</MDButton>

                <DataTable
                  striped
                  noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                                 fontWeight={'light'}>No
                    Member Data Found for Period</MDTypography>}
                  columns={columns}
                  keyField={'guid'}
                  data={resultsFiltered(reportData?.reportItems)}
                  onSort={handleSort}
                  highlightOnHover
                  onRowClicked={(row) => {
                    // handleRowClick(row);
                  }}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggledClearRows}
                  pagination
                  paginationPerPage={50}
                  paginationTotalRows={(resultsFiltered(reportData?.reportItems))?.length}
                  onChangePage={handlePageChange}
                  progressPending={!reportData}
                  defaultSortFieldId={getCookie('CUSTOMER_REPORT_SORT') || 2}
                  defaultSortAsc={getCookie('CUSTOMER_REPORT_SORT_DIR') === 'desc' ? false : true}
                  paginationComponentOptions={PaginationOptions}
                />

              </CardContent>
            </Card>

          </Grid>
          }
        </MDBox>
      </MDBox>

      {actionItemActive && <ActionItem actionType={actionItem}
                                       key={actionItem}
                                       actionUsers={selectedRows}
                                       defaultSelected={actionRecipients}
                                       callback={() => {
                                         setActionItemActive(false);
                                       }}
      />
      }
      <Footer mt={5}/>
    </DashboardLayout>
  );
}